import { frontendURL } from '../../../helper/URLHelper';

const NovidadesPage = () => import('./NovidadesPage.vue');

// A página de Novidades (22/10/2026): o que mudou no advup, contado com as cenas animadas. Chega pelo sino.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/novidades'),
    name: 'novidades_index',
    component: NovidadesPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
